module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANY THANKS TO")]), _vm._v(" those who helped with my work over the years: Kelli Auerbach, Skip Barton, Alexa Brandenberg, Mai-Lin Cheng, Eve and Carla Cohen, Kate Gadbow, Daniel Gaetán-Beltrán, Mark Girouard, Alaraby Johnson, Jeff Odefey, Mary Park, Scott Renschler, Robert Riger, Angela Robinson, Laura Rose, Ryan Shiraki, Lizzie Scott, Amanda Ward, and my patient professors Robert Coover, William Kittredge, Deirdre McNamer, Meredith Steinbach, and Ed White. I am indebted, as well, to Richard Ford, and to Denise and Mel Cohen for their award support.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thanks also to those who labored with me over these stories: Will Allyson, Brian Bouldrey, David Gilbert, Allyson Goldin, Rhian Ellis, Daniel Lee, J. Robert Lennon, Erika Mansourian, Jill Marquis, Andy and Alicia Paulson, Lois Rosenthal, and Ed Skoog.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Great thanks to George Witte, Josh Kendall, and everyone at Picador USA. Also to Kathy Robbins, Cory Halaby, Dorianne Steele, and the entire amazing Robbins Office. Greatest thanks of all goes to Bill Clegg, my agent, who always stood up for me, inspired me, and did everything but write these stories for me. Thanks, Bill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Most of all, I am grateful for the support of all my parents, my grandparents, my twin brother, Mike, and, of course, David Ross.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 66
// module chunks = 0